import "react-toastify/dist/ReactToastify.min.css";
import React, { createContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProcessingAnimation from "components/ProcessingAnimation/ProcessingAnimation.js";
import executeRequest from "../../../../modules/request.js";
import { DTConfigInGalleryContext } from "../scripts/DTConfigInGalleryContext.js";
import { BucketManager } from "../scripts/bucketManager.js";
import { updateStyle } from "../scripts/useStyle.js";
import Footer from "./footer/footer.js";
import LoginManager from "./login/loginManager.js";
import Main from "./main/main.js";
import NavBar from "./navbar/navBar.js";
import OrderingContainerManager from "./orderingContainer/orderingContainerManager.js";
import "../../../../../../shared/styles/colorDefinitions.css";
import { posthog } from "../../../../../../utils/InitPosthog.js";
import "../../../../style.css";
import HotkeyContextProvider from "src/merchant/v2/HotkeyContext/HotkeyContextProvider.js";
executeRequest("/api/public/users/gallery/isUserInReadonlyMode", "GET", {}).then((res) => {
    if (res.status === 200) {
        sessionStorage.setItem("logged", "true");
        setDTConfig((old) => ({ ...old, isLoggedIn: "true" }));
    }
    else {
        sessionStorage.setItem("logged", "false");
        setDTConfig((old) => ({ ...old, isLoggedIn: "false" }));
    }
});
export let openLoginMenu;
export let openAddingToBucketMenu;
const groupData = {
    categories: [],
    content: {
        info: "",
        infoBeforePayment: "",
        infoAfterPayment: "",
    },
    footer: "",
    clientData: {
        name: false,
        email: false,
        phone: false,
    },
    flow: undefined,
    appearance: {
        priceListType: "in_category",
        style: "purple",
    },
    payment: {
        electronic: false,
        cash: false,
    },
    contactData: "",
    hasAiModel: false,
    galleryName: "",
    groupName: "",
    _id: "",
    merchantSiteName: "",
    allowLoginToOrder: true,
    allImages: [],
};
export const defaultToastOptions = {
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    autoClose: 7000,
};
export const groupContext = createContext(groupData);
export let setDTConfig;
function Container() {
    var _a, _b;
    const [groupData, setGroupData] = useState(null);
    const [stylesLoading, setStylesLoading] = useState(true);
    const [DTConfig, setConfig] = useState({
        templatePool: "content-in-gallery",
        templateContext: {
            isLoggedIn: (_a = sessionStorage.getItem("logged")) !== null && _a !== void 0 ? _a : "false",
        },
    });
    const [update, triggerUpdate] = useState(0);
    setDTConfig = (update) => {
        setConfig({
            ...DTConfig,
            templateContext: update(DTConfig.templateContext),
        });
    };
    useEffect(() => {
        executeRequest("/api/public/users/gallery/getGroupData", "GET", {}).then((response) => {
            if (response.status == 401) {
                window.open("/client", "_self");
            }
            if (response.status == 200) {
                if (update === 0) {
                    posthog.capture("Gallery loaded", {
                        galleryName: response.galleryName,
                        groupName: response.groupName,
                    });
                }
                let categories = response.categories;
                if (response.privateSession) {
                    const imagesSet = new Set(response.privateSession.images);
                    categories = categories.map((category) => ({
                        ...category,
                        images: category.images.filter((image) => imagesSet.has(image.name)),
                    }));
                }
                setGroupData({
                    categories,
                    content: response.content,
                    footer: response.footer,
                    clientData: response.clientData,
                    payment: response.paymentMethods,
                    shipping: response.shipping,
                    inpostGeowidgetToken: response.inpostGeowidgetToken,
                    contactData: response.contactData,
                    appearance: response.appearance,
                    hasAiModel: response.hasAiModel,
                    galleryName: response.galleryName,
                    groupName: response.groupName,
                    flow: response.flow,
                    type: response.type,
                    stage: response.stage,
                    _id: response._id,
                    merchantSiteName: response.merchantSiteName,
                    allowLoginToOrder: response.allowLoginToOrder,
                    privateSession: response.privateSession,
                    allImages: response.categories.flatMap((category) => category.images),
                });
                if (response.type === "live" && response.stage !== "ready") {
                    setTimeout(() => {
                        triggerUpdate((old) => old + 1);
                    }, 1200);
                }
            }
        });
    }, [update]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!groupData)
            return;
        const style = (_b = (_a = groupData === null || groupData === void 0 ? void 0 : groupData.appearance) === null || _a === void 0 ? void 0 : _a.style) !== null && _b !== void 0 ? _b : "purple";
        const design = (_d = (_c = groupData === null || groupData === void 0 ? void 0 : groupData.appearance) === null || _c === void 0 ? void 0 : _c.design) !== null && _d !== void 0 ? _d : "default";
        updateStyle(style, design);
        setTimeout(() => {
            setStylesLoading(false);
        }, 500);
    }, [groupData]);
    useEffect(() => {
        const interval = setInterval(async () => {
            const response = await executeRequest("/api/public/users/gallery/isUserInReadonlyMode", "GET", {});
            const groupId = response.groupId;
            if (groupId !== (groupData === null || groupData === void 0 ? void 0 : groupData._id) && (groupData === null || groupData === void 0 ? void 0 : groupData._id) !== undefined) {
                location.assign(`/c/${groupData.merchantSiteName}?preLink=${groupData.galleryName}`);
            }
        }, 10000);
        return () => {
            clearInterval(interval);
        };
    }, [groupData]);
    return (React.createElement("div", { className: "container" },
        React.createElement(groupContext.Provider, { value: groupData },
            React.createElement(HotkeyContextProvider, null,
                React.createElement(DTConfigInGalleryContext.Provider, { value: DTConfig },
                    React.createElement(HashRouter, null,
                        React.createElement(ToastContainer, { position: "bottom-left" }),
                        React.createElement(NavBar, null),
                        React.createElement(Main, { categories: groupData === null || groupData === void 0 ? void 0 : groupData.categories, merchantInfoProps: (_b = groupData === null || groupData === void 0 ? void 0 : groupData.content) === null || _b === void 0 ? void 0 : _b.info, groupData: groupData }),
                        React.createElement(Footer, { merchantFooter: groupData === null || groupData === void 0 ? void 0 : groupData.footer, context: DTConfigInGalleryContext }),
                        React.createElement(LoginManager, { setFunction: function (newFunction) {
                                openLoginMenu = newFunction;
                            } }),
                        React.createElement(OrderingContainerManager, { setFunction: (newFunction) => (openAddingToBucketMenu = newFunction) }),
                        stylesLoading && (React.createElement("div", { className: "gallery-loading-animation-wrapper" },
                            React.createElement(ProcessingAnimation, { extraMessage: "Trwa \u0142adowanie galerii..." })))))))));
}
localStorage.setItem("checkIfTabExists", Date.now() + "");
localStorage.removeItem("checkIfTabExists");
window.addEventListener("storage", (event) => {
    if (event.key === "checkIfTabExists") {
        localStorage.removeItem("checkIfTabExists");
        window.close();
    }
});
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Container, null), document.body.querySelector("#container"));
export const bucketManager = new BucketManager();
